import {
  FeatureFlagContentValuesType,
  useFeatureFlag,
} from "contexts/FeatureFlagContext";
import _ from "lodash";
import { useEffect, useState } from "react";
import BusinessUnitAPI from "restAPI/BusinessUnitAPI";
import { UserPermissionResponseDto } from "types/api/userPermissionResponseDto";
import { generatePermissionTreeData } from "utils/treeUtils";

const FeatureFlagPermissionMapping = {
  EXCEPTION_MODULE: [
    "RISK_REGISTER",
    "READ_RISK_REGISTER",
    "APPROVE_RISK_REGISTER",
    "CREATE_RISK_REGISTER",
    "UPDATE_RISK_REGISTER",
    "DELETE_RISK_REGISTER",
    "UPDATE_FINDINGS_RISK_REGISTER",
    "MODIFY_APPROVERS_LIST",
  ],
  PENTEST_MODULE: [
    "ASSESSMENTS",
    "CREATE_ASSESSMENTS",
    "DELETE_ASSESSMENTS",
    "READ_ASSESSMENTS",
    "UPDATE_ASSESSMENTS",
    "UPDATE_FINDINGS_ASSESSMENT",
  ],
};

export default function useFetchAllPermissions(shouldFetch = true) {
  const [allPermissions, setAllPermissions] = useState<
    UserPermissionResponseDto[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const featureFlags = useFeatureFlag();

  useEffect(() => {
    if (!shouldFetch) return;
    setLoading(true);
    const { promise, cancel } = BusinessUnitAPI.getAllPermissions();
    promise
      .then(
        (response) => {
          const filteredPermissionTree: Record<
            string,
            Record<string, boolean>
          > = {};
          _.forEach(response, (values, key) => {
            // Check if the permission is controlled by a feature flag
            const featureControlled = _.findKey(
              FeatureFlagPermissionMapping,
              (permissions) => permissions.includes(key),
            );
            // If the permission is controlled by a feature flag, include it only if the flag is enabled
            if (
              !featureControlled ||
              featureFlags[
                featureControlled as keyof FeatureFlagContentValuesType
              ]
            ) {
              filteredPermissionTree[key] = {};
              values.forEach((value: string) => {
                if (
                  key === "FINDINGS" &&
                  value === "UPDATE_FINDINGS_RISK_REGISTER"
                ) {
                  if (featureFlags.EXCEPTION_MODULE) {
                    filteredPermissionTree[key][value] = true;
                  }
                } else if (
                  key === "FINDINGS" &&
                  value === "UPDATE_FINDINGS_ASSESSMENT"
                ) {
                  if (featureFlags.PENTEST_MODULE) {
                    filteredPermissionTree[key][value] = true;
                  }
                } else if (
                  key === "DASHBOARD" &&
                  value === "LIMITED_SHARE_DASHBOARD"
                ) {
                  if (featureFlags.DASHBOARD_RBAC) {
                    filteredPermissionTree[key][value] = true;
                  }
                } else {
                  filteredPermissionTree[key][value] = true;
                }
              });
            }
          });
          return generatePermissionTreeData(filteredPermissionTree);
        },
        (e) => console.error(e),
      )
      .then(setAllPermissions, _.noop)
      .finally(() => setLoading(false));

    return cancel;
  }, [featureFlags, shouldFetch]);

  return [allPermissions, loading];
}
